import { ResponsiveImageConfiguration } from './graphql/api/graphql';

const getDefaultImageUrls = (
  imageConfigurations: ResponsiveImageConfiguration[],
) => imageConfigurations.map(
  () => 'https://media.fashionunited.com/media/logos/defaultImageBlackHighonGrey.svg',
);

export default getDefaultImageUrls;
